export default "__VITE_ASSET__Bz0aXchu__"